export const STORAGE_AUTH_DATA = 'user';
export const STORAGE_STRIPE_DATA = 'stripe';
export const STORAGE_ACCOUNT_DATA = 'account';
export const STORAGE_COMPANY_DATA = 'company';
export const STORAGE_NEW_SIGNUP = 'new_signup';
export const STORAGE_CURRENT_FORM = 'current_form';
export const STORAGE_REGISTER_EMAIL = 'register_email';
export const STORAGE_REGISTER_PASSWORD = 'register_password';
export const STORAGE_RECENT_DATE_RANGES = 'recent_date_ranges';
